import { Button } from '@components/Button'
import { HeroIcon } from '@components/HeroIcon'
import { View, Text, YStack } from 'tamagui'
export function ActivityCardMessage() {
  return (
    <View>
      <View
        borderWidth={1}
        borderColor={'$success-300'}
        h={12}
        borderTopLeftRadius="$border-radius-lg"
        borderTopRightRadius="$border-radius-lg"
        backgroundColor={'$success-300'}
      ></View>

      <YStack
        alignItems="flex-start"
        borderWidth={1}
        borderColor="$neutral-200"
        borderBottomRightRadius="$border-radius-lg"
        borderBottomLeftRadius="$border-radius-lg"
        p={'$spacing-inset-xs'}
        gap={'$spacing-inset-xs'}
      >
        <View
          backgroundColor={'$neutral-100'}
          w={32}
          h={32}
          borderRadius="$border-radius-pill"
          alignItems="center"
          justifyContent="center"
        >
          <HeroIcon
            icon={['fal', 'trophy-star']}
            size={16}
            color="$success-300"
          />
        </View>

        <Text
          ff="$mulishSemiBold"
          fontSize="$font-size-xs"
          color="$neutral-800"
          fontWeight={600}
        >
          Parabéns pela aprovação! Você acertou 70% das questões.
        </Text>

        <Button variant="secondary" size="medium">
          <Text>Quero refazer</Text>
        </Button>
      </YStack>
    </View>
  )
}
